// import { ifNotAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/supply",
    name: "Supply",
    meta: { title: "Zaloga" },
    component: () => import(/* webpackChunkName: "Supply List" */ "@/Modules/Supply/Views/List")
    // beforeEnter: ifNotAuthenticated
  }
]
